import { render } from "./PendingApproved.vue?vue&type=template&id=f08e6c92"
import script from "./PendingApproved.vue?vue&type=script&lang=js"
export * from "./PendingApproved.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__